import React, { useState, useEffect } from "react";
import CreatableSelect from "react-select/creatable";
const Select2AcadTerm = ({ data, value, setValue }) => {
  const [localValue, setLocalValue] = useState(null);

  useEffect(() => {
    // Sync local value with prop value
    setLocalValue(value || null);
  }, [value]);

  if (!data || data.length === 0) return <div className="text-muted">No Type of Academic Calendar</div>;

  const options = data.map(item => ({
    value: item?.id,
    label: item?.name
  }))

  // Find the selected option object based on the value
  // Support both object {value, label} and primitive value
  const selectedOption = localValue
    ? (typeof localValue === 'object' && localValue.value !== undefined
      ? options.find(option => option.value === localValue.value)
      : options.find(option => option.value === localValue))
    : null;

  const handleChange = (selectedOption) => {
    // Save as object {value, label} instead of just value
    const newValue = selectedOption ? {
      value: selectedOption.value,
      label: selectedOption.label
    } : null;
    setLocalValue(newValue);
    setValue(newValue);
  };

  return (
    <CreatableSelect
      isMulti={false}
      isSearchable
      isClearable
      value={selectedOption}
      onChange={handleChange}
      options={options}
      placeholder="Select Term..."
      className="react-select-container"
      classNamePrefix="react-select"
      noOptionsMessage={() => "No type of term found"}
    />
  );
}

export {Select2AcadTerm}